module.exports = __webpack_public_path__ + "static/media/boy.8898d6bf.png";